import { contextPathUI } from '../../settings';

/**
 * Custom helper that provides a function to redirect and reload the page
 * while taking in consideration that the base path (contextPath) may be different from the root
 */
export const handleRedirectAndReload = (path, replace = false) => {
  const redirectPath = contextPathUI + path;

  if (replace) {
    window.location.replace(redirectPath);
  } else {
    window.location.href = redirectPath;
  }
};
